































































































































































































































































import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import { IRequisition, Requisition, RequisitionFilterParams } from '@/models';
import { IRequisitionFetchActionPayload } from '@/store/requisition';

import { createPdf, createFile } from '@/utils/helpers';
import Functions from '@/mixins/functions';
import mixins from '@/utils/mixins';
import Auth from '@/mixins/auth';

import RequisitionDetailFormDialog from '@/components/requisition/RequisitionDetailFormDialog.vue';
import RequisitionActivityDialog from '@/components/requisition/RequisitionActivityDialog.vue';
import RequisitionBulkUpdateOwnerDialog from '@/components/requisition/RequisitionBulkUpdateOwnerDialog.vue';
import RequisitionSearchFilter from '@/components/requisition/RequisitionSearchFilter.vue';
import { merge, omit } from 'lodash';
import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import RequisitionStatusDisplay from '@/components/requisition-common/RequisitionStatusDisplay.vue';
import { DataTableItemProps } from 'vuetify';

export default mixins(Functions, Auth).extend({
  name: 'RequisitionListPage',

  components: {
    RequisitionDetailFormDialog,
    RequisitionActivityDialog,
    RequisitionSearchFilter,
    RequisitionBulkUpdateOwnerDialog,
    ALPage,
    ErrorAlert,
    RequisitionStatusDisplay
  },

  data() {
    return {
      loading: false,
      exportLoading: false,
      formDialog: false,
      deleteDialog: false,
      sortBy: 'id',
      sortDesc: true,
      params: {
        search: this.$route.query.search as string,
        page: Number(this.$route.query.page ?? 1)
      } as IRequisitionFetchActionPayload,

      errorMessage: '',
      detailErrorMessage: '',

      headers: [
        {
          text: '',
          sortable: false,
          width: '1px',
          class: 'pr-0 mr-n3',
          value: 'data-table-select'
        },
        { text: 'Req #', sortable: false, value: 'id', width: 70 },
        {
          text: 'Requestor',
          sortable: false,
          value: 'owner.fullName',
          width: 200
        },
        { text: 'Supplier', sortable: false, value: 'supplier', width: 300 },

        { text: 'P.O #', sortable: false, value: 'po_number' },
        {
          text: 'Items',
          sortable: false,
          value: 'num_items',
          align: 'start',
          width: 60
        },
        {
          text: 'Currency',
          sortable: false,
          value: 'currency',
          align: 'center',
          width: 60
        },
        {
          text: 'Amount',
          sortable: false,
          value: 'amount',
          align: 'end',
          width: 130
        },
        {
          text: 'Needed By',
          sortable: false,
          value: 'required_date',
          width: 155
        },
        { text: '', sortable: false, value: 'is_urgent', width: 60 },
        {
          text: 'Status',
          sortable: false,
          value: 'status',
          align: 'center',
          width: 200
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
          align: 'center',
          width: 100
        }
      ],

      isSearchFilterActive: false,

      selectedRequisitions: [] as IRequisition[],
      bulkActionsMenu: false
    };
  },

  mounted() {
    // update `this.params` from the route query object.
    // omitting `search` and `page` as they are already set in the data vue option
    merge(this.params, omit(this.$route.query, ['page', 'search']));

    this.loading = true;
    this.searchRequisitions(this.params);
  },

  computed: {
    ...mapGetters({
      requisitions: 'requisition/getRequisitions',
      numQuotes: 'requisition/getRequisitionCount'
    }),

    extraFiltersApplied(): boolean {
      return Object.values(omit(this.$route.query, ['page', 'search'])).some(
        v => !!v
      );
    },

    isRequisitionSelected(): boolean {
      return this.selectedRequisitions.length != 0;
    },

    listPageHeight(): number {
      return this.isUserRequisitionAdmin ? 73 : 37;
    }
  },

  watch: {
    'params.search'(search: string) {
      this.debounceFetchRequisitions({
        ...this.params,
        search: search,
        page: 1
      }).then(() => {
        this.params.page = 1;
      });
    }
  },

  methods: {
    moment,

    ...mapActions({
      fetchRequisitions: 'requisition/fetchRequisitions',
      exportRequisitionPdf: 'requisition/exportRequisitionPdf',
      exportRequisitions: 'requisition/exportRequisitions'
    }),

    selectRequisition(requisition: IRequisition, props: DataTableItemProps) {
      if (this.isRequisitionSelected) {
        props.select(!props.isSelected);
      } else {
        this.routeToRequisition(requisition.id!);
      }
    },

    routeToRequisition(requisitionId: number) {
      this.$router.push({
        name: 'requisition-detail',
        params: {
          id: String(requisitionId)
        }
      });
    },

    exportPdf(requisition: Requisition) {
      this.loading = true;
      this.clearAllErrors();
      this.exportRequisitionPdf(requisition.id)
        .then((data: Blob) => {
          const fileName = `${requisition.id}-purchase-requisition-${moment(
            new Date()
          ).format('YYYY-MM-DD-HH-mm-ss')}`;
          createPdf(data, fileName);
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    exportRequisitionsCSV() {
      this.exportLoading = true;
      this.clearAllErrors();
      this.exportRequisitions(this.params)
        .then((data: Blob) => {
          const fileName = `purchase-requisitions-${moment(new Date()).format(
            'YYYY-MM-DD-HH-mm-ss'
          )}`;
          createFile(data, fileName, 'csv');
        })
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },

    createRequisition() {
      (this as any).$refs.requisitionDetailFormDialog.open();
    },

    openActivitesDialog(requisition: IRequisition) {
      const dialog = this.$refs.requisitionActivityDialog as InstanceType<
        typeof RequisitionActivityDialog
      >;
      dialog.open(requisition);
    },

    closeDelete() {
      this.deleteDialog = false;
      this.$nextTick(() => {
        //TODO: Add functionality
      });
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async debounceFetchRequisitions(params: IRequisitionFetchActionPayload) {
      this.clearAllErrors();
      this.loading = true;

      return await this.debounce(this.searchRequisitions, 200)(params);
    },

    /**
     * @param {IRequisitionFetchActionPayload} params
     */
    searchRequisitions(queryParams: IRequisitionFetchActionPayload) {
      const params = this.cleanFilterParams(queryParams);

      /* this will update the URL query based on param values. */
      this.$router
        .replace({
          name: 'requisition-list',
          query: params as Record<string, any>
        })
        .catch((e: Error) => e); //catch navigation duplication error

      return this.fetchRequisitions(params)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    ownerUpdateRefresh() {
      this.selectedRequisitions = [];
      this.searchRequisitions(this.params);
    },

    refreshSearchFilter(params: RequisitionFilterParams) {
      this.clearAllErrors();

      this.loading = true;
      this.searchRequisitions({
        // reset page to 1 when updating params
        page: 1,
        search: this.params.search,
        ...params
      }).then(() => {
        // update params object
        this.params.state = params.state;
        this.params.owner = params.owner;
        this.params.po_number = params.po_number;
        this.params.page = 1;
      });
    },

    cleanFilterParams(params: RequisitionFilterParams) {
      if (!this.isUserRequisitionAdmin) {
        delete params.owner;
      }
      return params;
    },

    onUpdatePage(newPage: number) {
      if (newPage != this.params.page) {
        this.debounceFetchRequisitions({
          ...this.params,
          page: newPage
        }).then(() => {
          this.params.page = newPage;
        });
      }
    }
  }
});
